import * as React from "react";
import classnames from "classnames";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { stockResolver } from "./helpers.js";
import { useStockIndicator } from "./StockIndicatorContext.js";
/* empty css                    */
const inventoryClassNames = {
  inStock: "in-stock",
  lowStock: "low-stock",
  veryLowStock: "very-low-stock",
  outOfStock: "out-of-stock",
  backOrder: "back-order",
  availableInStore: "available-in-store"
};
const StockIndicator = ({
  stockCount,
  allowBackOrder = true,
  channelAvailability = "IN_STORE_ONLY"
}) => {
  const { getLabel } = useIntl();
  const { thresholds } = useStockIndicator();
  const stock = stockResolver(channelAvailability, allowBackOrder, stockCount, thresholds);
  if (!stock) {
    return null;
  }
  const { labelId, tooltipId } = stock;
  const shouldShowTooltip = tooltipId || labelId === "backOrder";
  const inventoryClass = labelId.substr(labelId.lastIndexOf(".") + 1);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("stock-indicator", {
        [`stock-indicator--level-${inventoryClassNames[inventoryClass]}`]: inventoryClassNames[inventoryClass]
      }),
      "data-t": "stock-indicator"
    },
    /* @__PURE__ */ React.createElement("div", { className: "stock-indicator__levels" }, /* @__PURE__ */ React.createElement("span", { className: "stock-indicator__levels-level" })),
    /* @__PURE__ */ React.createElement("span", { className: "stock-indicator__label" }, getLabel(`products.stockInfo.${labelId}`)),
    shouldShowTooltip && // All stock levels can have a tooltip when configured through a custom config
    // inStockTooltip, lowStockTooltip, veryLowStockTooltip, outOfStockTooltip, backOrderTooltip
    /* @__PURE__ */ React.createElement(Toggletip, { message: getLabel(`products.stockInfo.${tooltipId || "backOrder"}Tooltip`) })
  );
};
export {
  StockIndicator,
  StockIndicator as default
};
//# sourceMappingURL=StockIndicator.js.map
